//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/Object.js";
import "../no/Annotations.js";
import "../no/Drawings.js";
import "../no/Layout2d.js";
import "../no/Part.js";
let d=[[],[[[],"CreatePreferencesBuilder",{R_:{builder:"Drafting.PreferencesBuilder"}},0,0],[["objects"],"CreateAnnotationEditSettingsBuilder",{R_:{builder:"Annotations.EditSettingsBuilder"}},1,0],[["sectionLines"],"CreateDrawingEditSectionLineSettingsBuilder",{R_:{builder:"Drawings.EditSectionLineSettingsBuilder"}},1,0],[["views"],"CreateDrawingEditViewSettingsBuilder",{R_:{builder:"Drawings.EditViewSettingsBuilder"}},1,0],[["components"],"CreateLayout2dEditComponentSettingsBuilder",{R_:{builder:"Layout2d.EditComponentSettingsBuilder"}},1,0],[["viewLabels"],"CreateDrawingEditViewLabelSettingsBuilder",{R_:{builder:"Drawings.EditViewLabelSettingsBuilder"}},1,0],[["objects"],"CreateTableEditSettingsBuilder",{R_:{builder:"Annotations.TableEditSettingsBuilder"}},1,0],[["editSettingsBuilders"],"ProcessForMutipleObjectsSettings",{},1,1],[["editSettingsBuilders"],"ProcessForMultipleObjectsSettings",{},1,0],[["objects"],"CreateTableRowSortingBuilder",{R_:{builder:"Annotations.TableRowSortingBuilder"}},1,0],[["tableObject"],"CreateTableRowSortingBuilderFromTable",{R_:{builder:"Annotations.TableRowSortingBuilder"}},1,0]],[]];
SPLM.Drafting.SettingsManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drafting.SettingsManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;